// Northeastern's undergraduate majors (#2652). Read on 2026-10-01 from
// Northeastern's official Academic Catalog (catalog.northeastern.edu/
// undergraduate/): each college's page and every department page it links,
// then each linked program's own page, whose title reads "<Name>, <bachelor's
// degree> (<campus>)" (one, Marine Biology, reads "BS with Three Seas"). The
// catalog lists the same major once per campus; here it appears once, with a
// note naming the campuses when it is not Boston only. Combined majors sit with
// the college whose catalog section holds them. Left out: minors, graduate and
// accelerated programs, and the College of Professional Studies (part-time
// programs for adult learners, not a first-year entry); Mills College at
// Northeastern lists only minors. The CAMD note quotes the Required Materials
// page (the college file's `requirements` source). Typography is plain ASCII
// ("Bouve" for Bouve College). The KB's majors list was the starting point;
// the catalog wins.
const majors = {
    "slug": "northeastern-university",
    "read": "2026-10-01",
    "intro": "Every undergraduate major in Northeastern's official Academic Catalog, grouped by the college that offers it, with the degree it leads to. Majors are on the Boston campus unless a note names another. Minors, graduate programs and the College of Professional Studies' programs for adult learners are left out.",
    "groups": [
        {
            "name": "College of Arts, Media and Design",
            "source": {
                "label": "Northeastern Academic Catalog, College of Arts, Media and Design",
                "url": "https://catalog.northeastern.edu/undergraduate/arts-media-design/"
            },
            "majors": [
                {
                    "name": "Acting",
                    "degree": "BFA",
                    "note": "Offered in New York"
                },
                {
                    "name": "Architectural Studies",
                    "degree": "BS"
                },
                {
                    "name": "Architectural Studies and Business Administration",
                    "degree": "BS"
                },
                {
                    "name": "Architectural Studies and Design",
                    "degree": "BS"
                },
                {
                    "name": "Architecture",
                    "degree": "BS"
                },
                {
                    "name": "Architecture and English",
                    "degree": "BS"
                },
                {
                    "name": "Art",
                    "degree": "BA"
                },
                {
                    "name": "Communication and Media Studies",
                    "degree": "BA"
                },
                {
                    "name": "Communication Studies",
                    "degree": "BA",
                    "note": "Offered in Boston and New York"
                },
                {
                    "name": "Communication Studies and Design",
                    "degree": "BS"
                },
                {
                    "name": "Communication Studies and Sociology",
                    "degree": "BA"
                },
                {
                    "name": "Communication Studies and Speech-Language Pathology and Audiology",
                    "degree": "BS"
                },
                {
                    "name": "Communication Studies and Theatre",
                    "degree": "BA"
                },
                {
                    "name": "Dance",
                    "degree": "BA",
                    "note": "Offered in New York"
                },
                {
                    "name": "Dance",
                    "degree": "BFA",
                    "note": "Offered in New York"
                },
                {
                    "name": "Design",
                    "degree": "BFA"
                },
                {
                    "name": "Design and Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Design and Public Health",
                    "degree": "BS"
                },
                {
                    "name": "Design and Theatre",
                    "degree": "BS"
                },
                {
                    "name": "Film and Creative Media",
                    "degree": "BA"
                },
                {
                    "name": "Film and Media Production",
                    "degree": "BFA",
                    "note": "Offered in New York"
                },
                {
                    "name": "Game Art and Animation",
                    "degree": "BFA"
                },
                {
                    "name": "Game Design",
                    "degree": "BFA"
                },
                {
                    "name": "Game Design and Music with Concentration in Music Technology",
                    "degree": "BS"
                },
                {
                    "name": "Journalism",
                    "degree": "BA",
                    "note": "Offered in Boston and New York"
                },
                {
                    "name": "Journalism and Communication Studies",
                    "degree": "BA"
                },
                {
                    "name": "Journalism and Cultural Anthropology",
                    "degree": "BA"
                },
                {
                    "name": "Journalism and Design",
                    "degree": "BS"
                },
                {
                    "name": "Journalism and English",
                    "degree": "BA"
                },
                {
                    "name": "Journalism and International Affairs",
                    "degree": "BA"
                },
                {
                    "name": "Journalism and Political Science",
                    "degree": "BA"
                },
                {
                    "name": "Journalism and Sociology",
                    "degree": "BA"
                },
                {
                    "name": "Landscape Architecture",
                    "degree": "BLA"
                },
                {
                    "name": "Media and Screen Studies",
                    "degree": "BA",
                    "note": "Offered in Boston and New York"
                },
                {
                    "name": "Media and Screen Studies and English",
                    "degree": "BA"
                },
                {
                    "name": "Media and Screen Studies and History",
                    "degree": "BA"
                },
                {
                    "name": "Media and Screen Studies and Journalism",
                    "degree": "BA"
                },
                {
                    "name": "Media and Screen Studies and Media Arts",
                    "degree": "BA"
                },
                {
                    "name": "Media and Screen Studies and Philosophy",
                    "degree": "BA"
                },
                {
                    "name": "Media and Screen Studies and Political Science",
                    "degree": "BA"
                },
                {
                    "name": "Media and Screen Studies and Sociology",
                    "degree": "BA"
                },
                {
                    "name": "Media and Screen Studies and Theatre",
                    "degree": "BA"
                },
                {
                    "name": "Media and Screen Studies and Theatre",
                    "degree": "BS"
                },
                {
                    "name": "Media Arts",
                    "degree": "BFA"
                },
                {
                    "name": "Media Arts and Communication Studies",
                    "degree": "BA"
                },
                {
                    "name": "Music",
                    "degree": "BA"
                },
                {
                    "name": "Music and Business Administration with Concentration in Music Industry",
                    "degree": "BS"
                },
                {
                    "name": "Music and Communication Studies with Concentration in Music Industry",
                    "degree": "BS"
                },
                {
                    "name": "Music with Concentration in Music Industry",
                    "degree": "BS"
                },
                {
                    "name": "Music with Concentration in Music Technology",
                    "degree": "BS"
                },
                {
                    "name": "Musical Theatre",
                    "degree": "BFA",
                    "note": "Offered in New York"
                },
                {
                    "name": "Performance and Extended Realities",
                    "degree": "BS"
                },
                {
                    "name": "Public Relations",
                    "degree": "BA",
                    "note": "Offered in Boston and New York"
                },
                {
                    "name": "Studio Art",
                    "degree": "BFA",
                    "note": "Offered in Boston and New York"
                },
                {
                    "name": "Theatre",
                    "degree": "BA",
                    "note": "Offered in Boston and New York"
                },
                {
                    "name": "Theatre",
                    "degree": "BS"
                },
                {
                    "name": "Theatre and Journalism",
                    "degree": "BA"
                },
                {
                    "name": "Theatre Design, Technology, and Stage Management",
                    "degree": "BFA",
                    "note": "Offered in New York"
                }
            ],
            "note": "Applicants to Performing Arts in New York City are required to audition or submit additional materials.",
            "noteSource": "requirements"
        },
        {
            "name": "D'Amore-McKim School of Business",
            "source": {
                "label": "Northeastern Academic Catalog, D'Amore-McKim School of Business",
                "url": "https://catalog.northeastern.edu/undergraduate/business/"
            },
            "majors": [
                {
                    "name": "Business Administration",
                    "degree": "BS",
                    "note": "Offered in New York"
                },
                {
                    "name": "Business Administration",
                    "degree": "BSBA",
                    "note": "Offered in Boston and Oakland"
                },
                {
                    "name": "Business Administration and Communication Studies",
                    "degree": "BS",
                    "note": "Offered in Boston and Oakland"
                },
                {
                    "name": "Business Administration and Criminal Justice",
                    "degree": "BS"
                },
                {
                    "name": "Business Administration and Design",
                    "degree": "BS",
                    "note": "Offered in Boston and Oakland"
                },
                {
                    "name": "Business Administration and Law",
                    "degree": "BS"
                },
                {
                    "name": "Business Administration and Psychology",
                    "degree": "BS",
                    "note": "Offered in Boston and Oakland"
                },
                {
                    "name": "Business Administration and Public Health",
                    "degree": "BS",
                    "note": "Offered in Boston and Oakland"
                },
                {
                    "name": "Business Administration and Public Relations",
                    "degree": "BS"
                },
                {
                    "name": "Interdisciplinary Studies",
                    "degree": "BS",
                    "note": "Offered in Oakland"
                },
                {
                    "name": "International Business",
                    "degree": "BS",
                    "note": "Offered in New York"
                },
                {
                    "name": "International Business",
                    "degree": "BSIB"
                },
                {
                    "name": "Quantitative Finance",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "Khoury College of Computer Sciences",
            "source": {
                "label": "Northeastern Academic Catalog, Khoury College of Computer Sciences",
                "url": "https://catalog.northeastern.edu/undergraduate/computer-information-science/"
            },
            "majors": [
                {
                    "name": "Artificial Intelligence",
                    "degree": "BS"
                },
                {
                    "name": "Artificial Intelligence and Behavioral Neuroscience",
                    "degree": "BS"
                },
                {
                    "name": "Artificial Intelligence and Biochemistry",
                    "degree": "BS"
                },
                {
                    "name": "Artificial Intelligence and Biology",
                    "degree": "BS"
                },
                {
                    "name": "Artificial Intelligence and Business Administration",
                    "degree": "BS"
                },
                {
                    "name": "Artificial Intelligence and Chemistry",
                    "degree": "BS"
                },
                {
                    "name": "Artificial Intelligence and Communication Studies",
                    "degree": "BS"
                },
                {
                    "name": "Artificial Intelligence and Criminal Justice",
                    "degree": "BS"
                },
                {
                    "name": "Artificial Intelligence and Design",
                    "degree": "BS"
                },
                {
                    "name": "Artificial Intelligence and Ecology and Evolutionary Biology",
                    "degree": "BS"
                },
                {
                    "name": "Artificial Intelligence and Economics",
                    "degree": "BS"
                },
                {
                    "name": "Artificial Intelligence and Environmental and Sustainability Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Artificial Intelligence and Health Science",
                    "degree": "BS"
                },
                {
                    "name": "Artificial Intelligence and International Affairs",
                    "degree": "BS"
                },
                {
                    "name": "Artificial Intelligence and Journalism",
                    "degree": "BS"
                },
                {
                    "name": "Artificial Intelligence and Linguistics",
                    "degree": "BS"
                },
                {
                    "name": "Artificial Intelligence and Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Artificial Intelligence and Philosophy",
                    "degree": "BS"
                },
                {
                    "name": "Artificial Intelligence and Physics",
                    "degree": "BS"
                },
                {
                    "name": "Artificial Intelligence and Psychology",
                    "degree": "BS"
                },
                {
                    "name": "Artificial Intelligence and Public Health",
                    "degree": "BS"
                },
                {
                    "name": "Artificial Intelligence and Sociology",
                    "degree": "BS"
                },
                {
                    "name": "Artificial Intelligence and Speech-Language Pathology and Audiology",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science",
                    "degree": "BACS"
                },
                {
                    "name": "Computer Science",
                    "degree": "BSCS",
                    "note": "Offered in Boston and Oakland"
                },
                {
                    "name": "Computer Science and Behavioral Neuroscience",
                    "degree": "BS",
                    "note": "Offered in Boston and Oakland"
                },
                {
                    "name": "Computer Science and Biology",
                    "degree": "BS",
                    "note": "Offered in Boston and Oakland"
                },
                {
                    "name": "Computer Science and Business Administration",
                    "degree": "BS",
                    "note": "Offered in Boston and Oakland"
                },
                {
                    "name": "Computer Science and Cognitive Psychology",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science and Communication Studies",
                    "degree": "BS",
                    "note": "Offered in Boston and Oakland"
                },
                {
                    "name": "Computer Science and Criminal Justice",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science and Design",
                    "degree": "BS",
                    "note": "Offered in Boston and Oakland"
                },
                {
                    "name": "Computer Science and Economics",
                    "degree": "BS",
                    "note": "Offered in Boston and Oakland"
                },
                {
                    "name": "Computer Science and English",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science and Environmental and Sustainability Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science and Game Development",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science and Health Science",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science and History",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science and Journalism",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science and Linguistics",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science and Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science and Media Arts",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science and Music",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science and Music with Concentration in Music Technology",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science and Philosophy",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science and Physics",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science and Political Science",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science and Politics, Philosophy, and Economics",
                    "degree": "BS",
                    "note": "Offered in Boston and Oakland"
                },
                {
                    "name": "Computer Science and Public Health",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science and Sociology",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science and Speech-Language Pathology and Audiology",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science and Theatre",
                    "degree": "BS"
                },
                {
                    "name": "Computing and Law",
                    "degree": "BS"
                },
                {
                    "name": "Cybersecurity",
                    "degree": "BS"
                },
                {
                    "name": "Cybersecurity and Business Administration",
                    "degree": "BS"
                },
                {
                    "name": "Cybersecurity and Criminal Justice",
                    "degree": "BS"
                },
                {
                    "name": "Cybersecurity and Economics",
                    "degree": "BS"
                },
                {
                    "name": "Cybersecurity and History",
                    "degree": "BS"
                },
                {
                    "name": "Cybersecurity and Political Science",
                    "degree": "BS"
                },
                {
                    "name": "Interdisciplinary Studies",
                    "degree": "BS",
                    "note": "Offered in Oakland"
                }
            ]
        },
        {
            "name": "College of Engineering",
            "source": {
                "label": "Northeastern Academic Catalog, College of Engineering",
                "url": "https://catalog.northeastern.edu/undergraduate/engineering/"
            },
            "majors": [
                {
                    "name": "Bioengineering",
                    "degree": "BSBioE"
                },
                {
                    "name": "Bioengineering and Behavioral Neuroscience",
                    "degree": "BSBioE"
                },
                {
                    "name": "Bioengineering and Biochemistry",
                    "degree": "BSBioE"
                },
                {
                    "name": "Chemical Engineering",
                    "degree": "BSChE"
                },
                {
                    "name": "Chemical Engineering and Artificial Intelligence",
                    "degree": "BSChE"
                },
                {
                    "name": "Chemical Engineering and Biochemistry",
                    "degree": "BSChE"
                },
                {
                    "name": "Chemical Engineering and Bioengineering",
                    "degree": "BSChE"
                },
                {
                    "name": "Chemical Engineering and Computer Science",
                    "degree": "BSChE"
                },
                {
                    "name": "Chemical Engineering and Environmental Engineering",
                    "degree": "BSChE"
                },
                {
                    "name": "Chemical Engineering and Physics",
                    "degree": "BSChE"
                },
                {
                    "name": "Civil Engineering",
                    "degree": "BSCE"
                },
                {
                    "name": "Civil Engineering and Architectural Studies",
                    "degree": "BSCE"
                },
                {
                    "name": "Civil Engineering and Business Administration",
                    "degree": "BSCE"
                },
                {
                    "name": "Civil Engineering and Computer Science",
                    "degree": "BSCE"
                },
                {
                    "name": "Computer Engineering",
                    "degree": "BSCmpE",
                    "note": "Offered in Boston and Oakland"
                },
                {
                    "name": "Computer Engineering and Computer Science",
                    "degree": "BSCmpE",
                    "note": "Offered in Boston and Oakland"
                },
                {
                    "name": "Computer Engineering and Physics",
                    "degree": "BSCmpE"
                },
                {
                    "name": "Electrical and Computer Engineering",
                    "degree": "BSCmpE",
                    "note": "Offered in Boston and Oakland"
                },
                {
                    "name": "Electrical and Computer Engineering",
                    "degree": "BSEE",
                    "note": "Offered in Boston and Oakland"
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "BSEE",
                    "note": "Offered in Boston and Oakland"
                },
                {
                    "name": "Electrical Engineering and Music with Concentration in Music Technology",
                    "degree": "BSEE"
                },
                {
                    "name": "Electrical Engineering and Physics",
                    "degree": "BSEE"
                },
                {
                    "name": "Environmental Engineering",
                    "degree": "BSEnvE"
                },
                {
                    "name": "Environmental Engineering and Artificial Intelligence",
                    "degree": "BSEnvE"
                },
                {
                    "name": "Environmental Engineering and Chemical Engineering",
                    "degree": "BSEnvE"
                },
                {
                    "name": "Environmental Engineering and Health Science",
                    "degree": "BSEnvE"
                },
                {
                    "name": "Environmental Engineering and Landscape Architecture",
                    "degree": "BSEnvE"
                },
                {
                    "name": "Industrial Engineering",
                    "degree": "BSIE"
                },
                {
                    "name": "Industrial Engineering and Business Administration",
                    "degree": "BSIE"
                },
                {
                    "name": "Industrial Engineering and Computer Science",
                    "degree": "BSIE"
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "BSME"
                },
                {
                    "name": "Mechanical Engineering and Bioengineering",
                    "degree": "BSME"
                },
                {
                    "name": "Mechanical Engineering and Computer Science",
                    "degree": "BSME"
                },
                {
                    "name": "Mechanical Engineering and Design",
                    "degree": "BSME"
                },
                {
                    "name": "Mechanical Engineering and History",
                    "degree": "BSME"
                },
                {
                    "name": "Mechanical Engineering and Physics",
                    "degree": "BSME"
                }
            ]
        },
        {
            "name": "Bouve College of Health Sciences",
            "source": {
                "label": "Northeastern Academic Catalog, Bouve College of Health Sciences",
                "url": "https://catalog.northeastern.edu/undergraduate/health-sciences/"
            },
            "majors": [
                {
                    "name": "Applied Psychology",
                    "degree": "BA",
                    "note": "Offered in New York"
                },
                {
                    "name": "Health Science",
                    "degree": "BS",
                    "note": "Offered in Boston, Oakland and New York"
                },
                {
                    "name": "Health Science and Business Administration",
                    "degree": "BS",
                    "note": "Offered in Boston and Oakland"
                },
                {
                    "name": "Health Science and Communication Studies",
                    "degree": "BS",
                    "note": "Offered in Boston and Oakland"
                },
                {
                    "name": "Health Science and Criminal Justice",
                    "degree": "BS"
                },
                {
                    "name": "Health Science and Law",
                    "degree": "BS"
                },
                {
                    "name": "Health Science and Psychology",
                    "degree": "BS",
                    "note": "Offered in Boston and Oakland"
                },
                {
                    "name": "Health Science and Sociology",
                    "degree": "BS"
                },
                {
                    "name": "Health Science and Spanish",
                    "degree": "BS"
                },
                {
                    "name": "Interdisciplinary Studies",
                    "degree": "BS",
                    "note": "Offered in Oakland"
                },
                {
                    "name": "Nursing",
                    "degree": "BSN"
                },
                {
                    "name": "Pharmaceutical Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Public Health",
                    "degree": "BA",
                    "note": "Offered in Boston, Oakland and New York"
                },
                {
                    "name": "Public Health and Communication Studies",
                    "degree": "BA",
                    "note": "Offered in Boston and Oakland"
                },
                {
                    "name": "Public Health and Cultural Anthropology",
                    "degree": "BA"
                },
                {
                    "name": "Public Health and Journalism",
                    "degree": "BA"
                },
                {
                    "name": "Public Health and Law",
                    "degree": "BA"
                },
                {
                    "name": "Public Health and Sociology",
                    "degree": "BA"
                },
                {
                    "name": "Speech-Language Pathology and Audiology",
                    "degree": "BS"
                },
                {
                    "name": "Speech-Language Pathology and Audiology and Behavioral Neuroscience",
                    "degree": "BS"
                },
                {
                    "name": "Speech-Language Pathology and Audiology and Human Services",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Science",
            "source": {
                "label": "Northeastern Academic Catalog, College of Science",
                "url": "https://catalog.northeastern.edu/undergraduate/science/"
            },
            "majors": [
                {
                    "name": "Applied Physics",
                    "degree": "BS"
                },
                {
                    "name": "Behavioral Neuroscience",
                    "degree": "BS",
                    "note": "Offered in Boston, Oakland and New York"
                },
                {
                    "name": "Behavioral Neuroscience and Design",
                    "degree": "BS",
                    "note": "Offered in Boston and Oakland"
                },
                {
                    "name": "Behavioral Neuroscience and Philosophy",
                    "degree": "BS"
                },
                {
                    "name": "Biochemistry",
                    "degree": "BS"
                },
                {
                    "name": "Biology",
                    "degree": "BS",
                    "note": "Offered in Boston, Oakland and New York"
                },
                {
                    "name": "Biology and English",
                    "degree": "BS"
                },
                {
                    "name": "Biology and International Business",
                    "degree": "BS"
                },
                {
                    "name": "Biology and Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Biology and Political Science",
                    "degree": "BS"
                },
                {
                    "name": "Biology and Public Health",
                    "degree": "BS"
                },
                {
                    "name": "Biomedical Physics",
                    "degree": "BS"
                },
                {
                    "name": "Cell and Molecular Biology",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry",
                    "degree": "BS"
                },
                {
                    "name": "Ecology and Evolutionary Biology",
                    "degree": "BS"
                },
                {
                    "name": "Environmental and Sustainability Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Environmental and Sustainability Sciences and Chemistry",
                    "degree": "BS"
                },
                {
                    "name": "Environmental and Sustainability Sciences and Economics",
                    "degree": "BS"
                },
                {
                    "name": "Environmental and Sustainability Sciences and Journalism",
                    "degree": "BS"
                },
                {
                    "name": "Environmental and Sustainability Sciences and Landscape Architecture",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Studies",
                    "degree": "BA",
                    "note": "Offered in Boston and New York"
                },
                {
                    "name": "Environmental Studies and History",
                    "degree": "BA"
                },
                {
                    "name": "Environmental Studies and International Affairs",
                    "degree": "BA"
                },
                {
                    "name": "Environmental Studies and Philosophy",
                    "degree": "BA"
                },
                {
                    "name": "Environmental Studies and Political Science",
                    "degree": "BA"
                },
                {
                    "name": "Interdisciplinary Studies",
                    "degree": "BS",
                    "note": "Offered in Oakland"
                },
                {
                    "name": "Linguistics",
                    "degree": "BS"
                },
                {
                    "name": "Linguistics and Communication Studies",
                    "degree": "BA"
                },
                {
                    "name": "Linguistics and Cultural Anthropology",
                    "degree": "BS"
                },
                {
                    "name": "Linguistics and English",
                    "degree": "BA"
                },
                {
                    "name": "Linguistics and Psychology",
                    "degree": "BS"
                },
                {
                    "name": "Linguistics and Speech-Language Pathology and Audiology",
                    "degree": "BS"
                },
                {
                    "name": "Marine Biology",
                    "degree": "BS"
                },
                {
                    "name": "Marine Biology with Three Seas",
                    "degree": "BS"
                },
                {
                    "name": "Mathematics",
                    "degree": "BA"
                },
                {
                    "name": "Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Mathematics and Business Administration",
                    "degree": "BS"
                },
                {
                    "name": "Mathematics and Philosophy",
                    "degree": "BS"
                },
                {
                    "name": "Mathematics and Physics",
                    "degree": "BS"
                },
                {
                    "name": "Mathematics and Political Science",
                    "degree": "BS"
                },
                {
                    "name": "Mathematics and Psychology",
                    "degree": "BS"
                },
                {
                    "name": "Mathematics and Sociology",
                    "degree": "BS"
                },
                {
                    "name": "Physics",
                    "degree": "BS"
                },
                {
                    "name": "Physics and Music with Concentration in Music Technology",
                    "degree": "BS"
                },
                {
                    "name": "Physics and Philosophy",
                    "degree": "BS"
                },
                {
                    "name": "Psychology",
                    "degree": "BS",
                    "note": "Offered in Boston and Oakland"
                },
                {
                    "name": "Psychology and Design",
                    "degree": "BS"
                },
                {
                    "name": "Psychology and Music",
                    "degree": "BS"
                },
                {
                    "name": "Psychology and Theatre",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Social Sciences and Humanities",
            "source": {
                "label": "Northeastern Academic Catalog, College of Social Sciences and Humanities",
                "url": "https://catalog.northeastern.edu/undergraduate/social-sciences-humanities/"
            },
            "majors": [
                {
                    "name": "Africana Studies",
                    "degree": "BA"
                },
                {
                    "name": "Africana Studies and Criminal Justice",
                    "degree": "BA"
                },
                {
                    "name": "Africana Studies and English",
                    "degree": "BA"
                },
                {
                    "name": "Africana Studies and Human Services",
                    "degree": "BA"
                },
                {
                    "name": "Africana Studies and Journalism",
                    "degree": "BA"
                },
                {
                    "name": "Africana Studies and Media and Screen Studies",
                    "degree": "BA"
                },
                {
                    "name": "Africana Studies and Political Science",
                    "degree": "BA"
                },
                {
                    "name": "American Sign Language and Human Services",
                    "degree": "BS"
                },
                {
                    "name": "American Sign Language and Linguistics",
                    "degree": "BS"
                },
                {
                    "name": "American Sign Language and Psychology",
                    "degree": "BS"
                },
                {
                    "name": "American Sign Language and Theatre",
                    "degree": "BS"
                },
                {
                    "name": "American Sign Language-English Interpreting",
                    "degree": "BS"
                },
                {
                    "name": "Creative Writing",
                    "degree": "BFA",
                    "note": "Offered in New York"
                },
                {
                    "name": "Criminal Justice and Journalism",
                    "degree": "BS"
                },
                {
                    "name": "Criminal Justice and Philosophy",
                    "degree": "BS"
                },
                {
                    "name": "Criminal Justice and Political Science",
                    "degree": "BS"
                },
                {
                    "name": "Criminal Justice and Psychology",
                    "degree": "BS"
                },
                {
                    "name": "Criminal Justice and Public Health",
                    "degree": "BS"
                },
                {
                    "name": "Criminal Justice and Sociology",
                    "degree": "BS"
                },
                {
                    "name": "Criminology and Criminal Justice",
                    "degree": "BS"
                },
                {
                    "name": "Cultural Anthropology",
                    "degree": "BA"
                },
                {
                    "name": "Cultural Anthropology",
                    "degree": "BS"
                },
                {
                    "name": "Cultural Anthropology and Health Science",
                    "degree": "BS"
                },
                {
                    "name": "Cultural Anthropology and Philosophy",
                    "degree": "BA"
                },
                {
                    "name": "Cultural Anthropology and Religious Studies",
                    "degree": "BA"
                },
                {
                    "name": "Cultural Anthropology and Theatre",
                    "degree": "BA"
                },
                {
                    "name": "Economics",
                    "degree": "BA"
                },
                {
                    "name": "Economics",
                    "degree": "BS"
                },
                {
                    "name": "Economics and Business Administration",
                    "degree": "BS",
                    "note": "Offered in Boston and Oakland"
                },
                {
                    "name": "Economics and Criminal Justice",
                    "degree": "BS"
                },
                {
                    "name": "Economics and Human Services",
                    "degree": "BS"
                },
                {
                    "name": "Economics and International Business",
                    "degree": "BS"
                },
                {
                    "name": "Economics and Journalism",
                    "degree": "BS"
                },
                {
                    "name": "Economics and Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Economics and Philosophy",
                    "degree": "BS"
                },
                {
                    "name": "Economics and Psychology",
                    "degree": "BS",
                    "note": "Offered in Boston and Oakland"
                },
                {
                    "name": "English",
                    "degree": "BA",
                    "note": "Offered in Boston and New York"
                },
                {
                    "name": "English and Communication Studies",
                    "degree": "BA"
                },
                {
                    "name": "English and Criminal Justice",
                    "degree": "BA"
                },
                {
                    "name": "English and Cultural Anthropology",
                    "degree": "BA"
                },
                {
                    "name": "English and Design",
                    "degree": "BA"
                },
                {
                    "name": "English and Philosophy",
                    "degree": "BA"
                },
                {
                    "name": "English and Political Science",
                    "degree": "BA"
                },
                {
                    "name": "English and Theatre",
                    "degree": "BA"
                },
                {
                    "name": "Global Asian Studies",
                    "degree": "BA"
                },
                {
                    "name": "Health Humanities and Health Science",
                    "degree": "BS"
                },
                {
                    "name": "Health Humanities and Public Health",
                    "degree": "BA"
                },
                {
                    "name": "History",
                    "degree": "BA",
                    "note": "Offered in Boston and New York"
                },
                {
                    "name": "History",
                    "degree": "BS"
                },
                {
                    "name": "History and Asian Studies",
                    "degree": "BA"
                },
                {
                    "name": "History and Criminal Justice",
                    "degree": "BA"
                },
                {
                    "name": "History and Cultural Anthropology",
                    "degree": "BA"
                },
                {
                    "name": "History and Economics",
                    "degree": "BA"
                },
                {
                    "name": "History and Economics",
                    "degree": "BS"
                },
                {
                    "name": "History and English",
                    "degree": "BA"
                },
                {
                    "name": "History and Linguistics",
                    "degree": "BS"
                },
                {
                    "name": "History and Philosophy",
                    "degree": "BA"
                },
                {
                    "name": "History and Political Science",
                    "degree": "BA"
                },
                {
                    "name": "History and Religious Studies",
                    "degree": "BA"
                },
                {
                    "name": "History, Culture, and Law",
                    "degree": "BA",
                    "note": "Offered in Boston and New York"
                },
                {
                    "name": "Human Services",
                    "degree": "BA"
                },
                {
                    "name": "Human Services",
                    "degree": "BS"
                },
                {
                    "name": "Human Services and Communication Studies",
                    "degree": "BA"
                },
                {
                    "name": "Human Services and Criminal Justice",
                    "degree": "BS"
                },
                {
                    "name": "Human Services and International Affairs",
                    "degree": "BA"
                },
                {
                    "name": "Human Services and Psychology",
                    "degree": "BS"
                },
                {
                    "name": "Human Services and Public Health",
                    "degree": "BA"
                },
                {
                    "name": "Human Services and Sociology",
                    "degree": "BA"
                },
                {
                    "name": "Human Services and Sociology",
                    "degree": "BS"
                },
                {
                    "name": "International Affairs",
                    "degree": "BA",
                    "note": "Offered in Boston and New York"
                },
                {
                    "name": "International Affairs and Criminal Justice",
                    "degree": "BA"
                },
                {
                    "name": "International Affairs and Cultural Anthropology",
                    "degree": "BA"
                },
                {
                    "name": "International Affairs and Economics",
                    "degree": "BA"
                },
                {
                    "name": "International Affairs and History",
                    "degree": "BA"
                },
                {
                    "name": "International Affairs and International Business",
                    "degree": "BS"
                },
                {
                    "name": "International Affairs and Religious Studies",
                    "degree": "BA"
                },
                {
                    "name": "Jewish Studies and Religion",
                    "degree": "BA"
                },
                {
                    "name": "Philosophy",
                    "degree": "BA",
                    "note": "Offered in Boston and New York"
                },
                {
                    "name": "Philosophy",
                    "degree": "BS"
                },
                {
                    "name": "Political Science",
                    "degree": "BA"
                },
                {
                    "name": "Political Science",
                    "degree": "BS"
                },
                {
                    "name": "Political Science and Business Administration",
                    "degree": "BS"
                },
                {
                    "name": "Political Science and Communication Studies",
                    "degree": "BA"
                },
                {
                    "name": "Political Science and Communication Studies",
                    "degree": "BS"
                },
                {
                    "name": "Political Science and Economics",
                    "degree": "BA"
                },
                {
                    "name": "Political Science and Economics",
                    "degree": "BS"
                },
                {
                    "name": "Political Science and Human Services",
                    "degree": "BA"
                },
                {
                    "name": "Political Science and Human Services",
                    "degree": "BS"
                },
                {
                    "name": "Political Science and International Affairs",
                    "degree": "BA"
                },
                {
                    "name": "Political Science and Philosophy",
                    "degree": "BA"
                },
                {
                    "name": "Political Science and Philosophy",
                    "degree": "BS"
                },
                {
                    "name": "Politics, Philosophy, and Economics",
                    "degree": "BS",
                    "note": "Offered in Boston and Oakland"
                },
                {
                    "name": "Politics, Philosophy, and Economics and Business Administration",
                    "degree": "BS",
                    "note": "Offered in Boston and Oakland"
                },
                {
                    "name": "Religious Studies",
                    "degree": "BA"
                },
                {
                    "name": "Religious Studies and Africana Studies",
                    "degree": "BA"
                },
                {
                    "name": "Sociology",
                    "degree": "BA"
                },
                {
                    "name": "Sociology",
                    "degree": "BS"
                },
                {
                    "name": "Sociology and Cultural Anthropology",
                    "degree": "BA"
                },
                {
                    "name": "Sociology and Cultural Anthropology",
                    "degree": "BS"
                },
                {
                    "name": "Sociology and Environmental Studies",
                    "degree": "BA"
                },
                {
                    "name": "Sociology and International Affairs",
                    "degree": "BA"
                },
                {
                    "name": "Sociology and Philosophy",
                    "degree": "BA"
                },
                {
                    "name": "Sociology and Political Science",
                    "degree": "BA"
                },
                {
                    "name": "Sociology and Religious Studies",
                    "degree": "BA"
                },
                {
                    "name": "Spanish",
                    "degree": "BA"
                },
                {
                    "name": "Spanish and International Affairs",
                    "degree": "BA"
                },
                {
                    "name": "Spanish and Linguistics",
                    "degree": "BA"
                },
                {
                    "name": "Spanish and Public Health",
                    "degree": "BA"
                }
            ]
        }
    ]
};

export default majors;
